<template>
	<div class="page">
		<top-header></top-header>
		<b-container fluid>
			<b-row class="mt-3 mb-2">
				<b-col>
					<!--<b-img :src="$root.httpurl+$session.get('user_info').permissions.logo_left" v-if="$session.get('user_info').permissions.logo_left!=''" fluid alt="Fluid image" style="max-width:100px;" class="my-2"></b-img>-->
				</b-col>
				<b-col>
					<h2 class="text-center text-uppercase"><b>{{page_title}}</b></h2>
				</b-col>
				<b-col class="text-right">
					<!--<b-img :src="$root.httpurl+$session.get('user_info').permissions.logo_right" fluid alt="EESL" style="max-width:100px;" class="mr-2"></b-img>-->
				</b-col>
			</b-row>
		</b-container>
		<b-container fluid>
			<b-row>
				<b-col class="col-md-12 col-sm-12 col-xs-12">
					<div class="container-box">
						<b-row class="mt-4 px-3">
							<b-col lg="6">
								<span class="mr-2">Show</span>
								<b-form-select v-model="perPage" id="perPageSelect" :options="pageOptions" size="sm" class="w-25">
								</b-form-select>
								<span class="ml-2">entries</span>
							</b-col>
							<b-col lg="4" offset-md="2">
								<b-form-group label="Filter" label-cols-sm="3" label-align-sm="right" label-size="sm" label-for="filterInput" class="mb-0">
									<b-input-group size="sm">
										<b-form-input v-model="filter" type="search" id="filterInput" placeholder="Type to Search">
										</b-form-input>
										<b-input-group-append>
											<b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
										</b-input-group-append>
									</b-input-group>
								</b-form-group>
							</b-col>
						</b-row>
						<b-row class="px-3 pt-3">
							<b-col lg="12">
								<b-table show-empty sticky-header small striped outlined id="my-table" stacked="md" :items="records" :fields="fields" :current-page="currentPage" :per-page="perPage" :filter="filter" :filterIncludedFields="filterOn" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered">
									<template v-slot:cell(no_of_fittings)="row">
										<a :href="'/controllers/'+row.item.feeder_pillar_no" v-if="row.item.connections > 0"><b-badge pill variant="success">{{row.item.connections}}</b-badge></a>
										<b-badge pill variant="success" v-else>{{row.item.no_of_fittings}}</b-badge>
									</template>
									<template v-slot:cell(maintenance)="row">
										<b-badge pill variant="warning" v-if="row.value == 1">YES</b-badge>
										<b-badge pill variant="secondary" v-else>NO</b-badge>
									</template>
									<template v-slot:cell(door_status)="row">
										<b-badge pill variant="danger" v-if="row.value == 1">OPENED</b-badge>
										<b-badge pill variant="success" v-else>CLOSED</b-badge>
									</template>
									<template v-slot:cell(feeder_pillar_no)="row">
										<b-link :href="'/device-data/'+row.item.imei_no">{{row.value}}</b-link>
									</template>
									<template v-slot:cell(connection_status)="row">
										<b-link :href="'/device-fault/'+row.item.imei_no" v-if="row.value == 2"><div><b-badge pill variant="warning">DATA FAULT</b-badge></div></b-link>
										<b-badge pill variant="danger" v-else-if="row.value == 0">DISCONNECTED</b-badge>
										<b-badge pill variant="success" v-else>CONNECTED</b-badge>
									</template>
									<template v-slot:cell(actions)="row">
										<b-button pill variant="info" class="mr-1 icon-btn" v-if="$root.chkperm('page_devices','view')" @click="showViewModal(row.item, $event.target)" size="sm"><b-icon icon="search" font-scale="2" ></b-icon></b-button>
										<b-button pill variant="primary" class="mr-1 icon-btn" v-if="$root.chkperm('page_devices','edit')" @click="showUpdateModal(row.item, row.index, $event.target)" size="sm"><b-icon icon="pencil" font-scale="2" ></b-icon></b-button>
										<b-button pill variant="danger" class="mr-1 icon-btn" v-if="$root.chkperm('page_devices','delete')" @click="showDeleteModal(row.item)" size="sm"><b-icon icon="trash" font-scale="2" ></b-icon></b-button>
									</template>
								</b-table>
							</b-col>
						</b-row>
						<b-row class="px-3">
							<b-col lg="6">
								<span class="mr-2">Showing {{currentPage}} to {{(perPage>records.length)?records.length:perPage}} of {{records.length}} entries</span>
							</b-col>
							<b-col lg="3" offset-md="3">
								<b-pagination v-model="currentPage" pills :total-rows="totalRows" :per-page="perPage" align="right" size="sm" prev-text="Prev" next-text="Next" first-number last-number></b-pagination>
							</b-col>
						</b-row>
					</div>
				</b-col>
			</b-row>
			<b-container fluid>
				<b-row class="my-3">
					<b-col md="12">
						<line-chart ref="livechart" height="100"/>
					</b-col>
				</b-row>
			</b-container>
			<b-row class="my-3">
				<b-col>
					<img src="../assets/flag-green.svg" style="width: 40px; max-height:40px;"/>
					<span class="pl-3 text-sm"><b>DEVICE ON</b></span>
				</b-col>
				<b-col>
					<img src="../assets/flag-red.svg" style="width: 40px; max-height:40px;"/>
					<span class="pl-3 text-sm"><b>DEVICE OFF</b></span>
				</b-col>
				<b-col>
					<img src="../assets/flag-blue.svg" style="width: 40px; max-height:40px;"/>
					<span class="pl-3 text-sm"><b>TEMPORARY SIGNAL LOSS</b></span>
				</b-col>
				<b-col>
					<span class="float-right text-sm pt-2"><b>LAST SYNC TIME: {{last_sync_time}}</b></span>
				</b-col>
			</b-row>
			<b-row class="my-3">
				<b-col>
					<gmap-map :center="center" :zoom="zoneinfo.zoom" class="googlemap">
						<gmap-info-window :options="infoOptions" :position="infoWindowPos" :opened="infoWindowOpen" @closeclick="infoWindowOpen=false"></gmap-info-window>
						<gmap-marker :key="index" v-for="(m, index) in markers" :position="m.position" :clickable="true" :icon="m.icon" @click="toogleMarkerInfoWindow(m,index)"></gmap-marker>
					</gmap-map>
				</b-col>
			</b-row>
			<b-modal id="view-model" title="View DCU" ok-only @hide="setMaintenance">
				<b-container fluid>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">IMEI :</b-col>
						<b-col cols="8">{{selectedItem.imei_no}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Zone :</b-col>
						<b-col cols="8">{{selectedItem.ulb_id}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Feeder Pillor No :</b-col>
						<b-col cols="8">{{selectedItem.feeder_pillar_no}}</b-col>
					</b-row>
					<b-row class="mb-1r">
						<b-col cols="4" class="text-right">Ward No :</b-col>
						<b-col cols="8">{{selectedItem.ward_no}}</b-col>
					</b-row>
				</b-container>
				<template v-slot:modal-footer="{ ok, close, hide }">
					<div v-if="$root.chkperm('page_devices','maintenance')">
						<b-button size="sm" variant="warning" v-if="selectedItem.maintenance == 0" @click="hide('maintenance_on')">Maintenance ON</b-button>
						<b-button size="sm" variant="warning" v-else @click="hide('maintenance_off')">Maintenance OFF</b-button>
					</div>
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">Ok</b-button>
				</template>
			</b-modal>
			
			<b-modal id="edit-model" :title="(selectedItem.id > 0)?'Edit CCMS | DCU':'Add CCMS | DCU'" size="lg" ok-only @hidden="resetSelectedItem" @ok="modalSubmit">
				<b-container fluid>
					<b-row class="mb-1">
						<b-col>
							<b-alert show variant="secondary" class="header-title">Device Information</b-alert>
							<b-form-group label="Imei" label-for="imei-input" label-cols="4" label-size="sm" label-align-sm="right" invalid-feedback="Imei is required">
								<b-form-input id="imei-input" v-model="selectedItem.imei_no" :disabled="selectedItem.id > 0" required></b-form-input>
							</b-form-group>
							<b-form-group label="Feeder Piller No" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fp-input" v-model="selectedItem.feeder_pillar_no" required></b-form-input>
							</b-form-group>
							<b-form-group label="Device Type" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.device_type">
									<b-form-select-option value="CCMS">CCMS</b-form-select-option>
									<b-form-select-option value="DCU">DCU</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Device No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ccms-input" v-model="selectedItem.device_no" required></b-form-input>
							</b-form-group>
							<b-form-group label="Mobile No" label-for="ccms-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="mobile-input" v-model="selectedItem.mobile_no" required></b-form-input>
							</b-form-group>
							<b-alert show variant="secondary" class="header-title">Map Information</b-alert>
							<b-form-group label="Latitude" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.location_lat" required></b-form-input>
							</b-form-group>
							<b-form-group label="Longitude" label-for="poles-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="poles-input" v-model="selectedItem.location_lng" required></b-form-input>
							</b-form-group>
						</b-col>
						<b-col>
							<b-alert show variant="secondary" class="header-title">Location Information</b-alert>
							<b-form-group label="State" label-for="fp-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.state_id" :options="$root.state_options" @change="selectedItem.zone_id=0; selectedItem.ulb_id=0" required></b-form-select>
							</b-form-group>
							<b-form-group label="Zone" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.zone_id">
									<b-form-select-option value="0">--- Select Zone ---</b-form-select-option>
									<b-form-select-option v-for="item in filterZone(zoneOptions)" v-bind:key="item.id" :value="item.id" @change="selectedItem.ulb_id=0">{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="ULB" label-for="title" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-select v-model="selectedItem.ulb_id">
									<b-form-select-option value="0">--- Select ULB ---</b-form-select-option>
									<b-form-select-option v-for="item in filterULB(zoneOptions)" v-bind:key="item.id" :value="item.id" >{{item.title}}</b-form-select-option>
								</b-form-select>
							</b-form-group>
							<b-form-group label="Location" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="location-input" v-model="selectedItem.location" required></b-form-input>
							</b-form-group>
							<b-form-group label="Ward No" label-for="ward-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="ward-input" v-model="selectedItem.ward_no" required></b-form-input>
							</b-form-group>
							
							<b-form-group label="Total Load" label-for="load-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="load-input" v-model="selectedItem.total_load" required></b-form-input>
							</b-form-group>
							<b-form-group label="Total Connection" v-if="selectedItem.device_type === 'CCMS'" label-for="poles-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="poles-input" v-model="selectedItem.total_connection" required></b-form-input>
							</b-form-group>
							<b-form-group label="No of Fittings" label-for="fitting-input" label-cols="4" label-size="sm" label-align-sm="right">
								<b-form-input id="fitting-input" v-model="selectedItem.no_of_fittings" required></b-form-input>
							</b-form-group>
						</b-col>
					</b-row>
				</b-container>
				<form ref="form" @submit.stop.prevent="handleSubmit">
					
				</form>
				<template v-slot:modal-footer="{ ok, close }">
					<b-button size="sm" variant="danger" @click="close()">Cancel</b-button>
					<b-button size="sm" variant="success" @click="ok()">{{(selectedItem.id > 0)?'Update':'Submit'}}</b-button>
				</template>
			</b-modal>
		
		</b-container>
		<transition name="fade">
			<b-row v-if="loading" class="loading" style="position: absolute; top:0px; left:0px; right:0px; bottom:0px; z-index: 1000; background-color: rgba(0,0,0,0.4);" align-v="center" align-h="center">
				<b-spinner label="Busy" variant="light"></b-spinner>
			</b-row>
		</transition>
	</div>
	
</template>
<script>
import Header from "@/components/Header.vue";
import { Line } from 'vue-chartjs';
export default {
	name: 'Devices',
	components: {
		"top-header": Header,
		"line-chart": Line,
	},
	mounted(){
		var userinfo = this.$session.get('user_info');
		if(userinfo.role != 1){
			this.fields.splice(6,1);
			this.fields.splice(4,1);
			this.fields.splice(3,1);
		}
		this.$refs.livechart.renderChart({
			labels: ['January', 'February', 'March', 'April', 'May', 'June'],
			datasets: [
				{
					label: ' CCMS CONNECTED',
					borderColor: '#000099',
					backgroundColor: '#99d6ff',
					data: [8275, 5025, 6520, 3562, 5862, 6357],
					fill: false,
					lineTension: 0,
				},
				{
					label: ' CCMS ON',
					borderColor: '#009900',
					backgroundColor: '#00ff04',
					data: [7514, 9652, 4578, 3562, 8562, 1457],
					fill: false,
					lineTension: 0,
				},
				{
					label: ' LOAD',
					borderColor: '#f79800',
					backgroundColor: '#ffb642',
					data: [5236, 5025, 2365, 3562, 5862, 6357],
					fill: false,
					lineTension: 0,
				}
			]},{
			responsive: true
		});
		this.loadzones()
		this.initload();
	},
	data() {
		var self = this;
		
		return{
			loading: true, 
			last_sync_time: '',
			zoneOptions: [],
			page_title: '',
			selectedUlb: self.$route.params.ulbareacode,
			zonesUrl: self.$session.get('apiurl')+'api/zone-list',
			recordUrl: self.$session.get('apiurl')+'api/device-ulbs',
			insertUrl: self.$session.get('apiurl')+'api/device-insert',
			updateUrl: self.$session.get('apiurl')+'api/device-update',
			deleteUrl: self.$session.get('apiurl')+'api/device-delete',
			maintenanceUrl: self.$session.get('apiurl')+'api/device-maintenance',
			total_kwh: 0,
			device_on: 0,
			device_connected: 0,
			total_load: 0,
			current_load: 0,
			total_lights: 0,
			total_light_on: 0,
			total_light_off: 0,
			total_signal_loss: 0,
			records: [],
			fields: [
				{ key: 'sno', label: 'S.No' },
				{ key: 'feeder_pillar_no', label: 'F. No.', sortable: true, class: 'text-center' },
				{ key: 'location', label: 'Location', sortable: true, class: 'text-left' },
				{ key: 'imei_no', label: 'IMEI', sortable: true, sortDirection: 'desc' },
				{ key: 'mobile_no', label: 'Mobile No', sortable: true, sortDirection: 'desc' },
				{ key: 'no_of_fittings', label: 'Fittings', sortable: false,	sortByFormatted: true, filterByFormatted: true },
				{ key: 'device_type', label: 'Type' },
				{ key: 'total_load', label: 'Total Load', class: 'text-right',
					formatter: (value) => { 
						return (value/1000).toFixed(3);
					},
				},
				{ key: 'total_kw', label: 'Actual Load', class: 'text-right',
					formatter: (value, key, item) => { 
						if(item.output_status == 0 && (parseInt(item.amp_r/1000) < self.$root.correction_amp || parseInt(item.amp_y/1000) < self.$root.correction_amp || parseInt(item.amp_b/1000) < self.$root.correction_amp)){
							value = 0;
						}
						return (value/100000).toFixed(3);
					},
				},
				{ key: 'supply', label: 'Supply', 
					formatter: (value, key, item) => {
						var supply = 'MAIN';
						if(item.supply > 120){
							supply = 'BATTERY';
						}
						return supply;
					},
				},
				{ key: 'door_status', label: 'Door Status' },
				{ key: 'output_status', label: 'Output' , 
					formatter: (value) => {
						if(value == 0){
							return 'OFF';
						}
						return 'ON';
					},
				},
				{ key: 'update_time', label: 'TimeStamp', 
					formatter: (value, key, item) => {
						if(item.data_fault == 1){
							return self.$moment(item.fault_time).format('DD-MM-YYYY HH:mm:ss');
						}
						if(item.update_time == "" || item.update_time == "00-00-0000 00:00:00"){
							return '-n/a-';
						}
						return self.$moment(item.update_time).format('DD-MM-YYYY HH:mm:ss');
					},
				},
				{ key: 'connection_status', label: 'Network Status', sortable: true,
					formatter: (value, key, item) => {
						if(item.data_fault == 1){
							return 2;
						}
						return value;
					}
				},
				{ key: 'maintenance', label: 'Mnt.', sortable: true },
				{ key: 'actions', label: 'Actions', 'extra': 1 }
			],
			totalRows: 1,
			currentPage: 1,
			pageOptions: [10, 20, 50, 100],
			perPage: 10,
			sortBy: '',
			sortDesc: false,
			sortDirection: 'asc',
			filter: null,
			filterOn: [],
			selectedItem: {},
			emptyItem: {
				id: 0,
				imei_no: '',
				zone_id: 0,
				state_id: 0,
				ulb_id: 0,
				feeder_pillar_no: '',
				ward_no: '',
				ccms_no: '',
				total_load: '',
				total_connection: 0,
				no_of_poles: 0,
				no_of_fittings: 0,
				location_lat: '',
				location_lng: '',
				maintenance: 0
			},

			center: { lat: 0, lng: 0 },
			markers: [],
			places: [],
			currentPlace: null,
			infoWindowPos: null,
			infoWindowOpen: false,
			currentMarkerIndex: null,
			zoneinfo: {},
			infoOptions: {
				content: '',
				pixelOffset: {
					width: 0,
					height: -35
				}
			},
		};
	},
	methods: {
		setMaintenance(val){
			var self = this;
			var maintenance_flag = -1;
			if(val.trigger == "maintenance_on"){
				maintenance_flag = 1;
			}
			else if(val.trigger == "maintenance_off"){
				maintenance_flag = 0;
			}

			if(maintenance_flag >= 0){
				var submitdata = new Object();
				submitdata.feeder_pillar_no = self.selectedItem.feeder_pillar_no;
				submitdata.maintenance = maintenance_flag;

				self.loading = true;
				//bvModalEvt.preventDefault();

				self.axios.post(self.maintenanceUrl, {
					accesskey: self.$session.get('access_key'),
					data: submitdata
				})
				.then(function (response) {
					if(response.data.error == 0 || response.data.error == '0'){
						self.$bvModal.hide('view-model');
						self.$bvToast.toast(response.data.message, {
							title: 'Status',
							toaster: 'b-toaster-bottom-right',
							autoHideDelay: 5000,
							variant: 'warning',
							solid: true,
							appendToast: true
						});
						self.initload();
					}
					
				})
				.catch(function (error) {
					alert(error);
				});
			}
		},
		toogleMarkerInfoWindow(marker, index){
			this.infoWindowPos = marker.position;
			this.infoOptions.content = marker.infotext;
			if(this.currentMarkerIndex == index){
				this.infoWindowOpen = !this.infoWindowOpen;
			}else{
				this.infoWindowOpen = true;
				this.currentMarkerIndex = index;
			}
		},
		addMarker(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 35, height: 45, f: 'px', b: 'px'}, scaledSize: {width: 35, height: 45, f: 'px', b: 'px',}} });
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			this.center = marker;
			this.currentPlace = null;
		},
		addMarker2(lat, lng, infotext, iconurl) {
			const marker = {
				lat: lat,
				lng: lng
			};
			//this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl,size: {width: 60, height: 90, f: 'px', b: 'px'}, scaledSize: {width: 30, height: 45, f: 'px', b: 'px',}} });
			this.markers.push({ position: marker, infotext: infotext, icon: {url:iconurl} });
			//this.places.push(this.currentPlace);
			this.center = marker;
			this.currentPlace = null;
		},
		filterZone: function (items) {
			var self = this;
			return items.filter(function (item) {
				if(item.parent ==0){
					return item.state  == self.selectedItem.state_id;
				}
			})
		},
		filterULB: function (items) {
			var self = this;
			return items.filter(function (item) {
				return item.parent == self.selectedItem.zone_id && item.parent > 0;
			})
		},
		showAddModal(){
			var self = this;
			this.selectedItem = Object.assign({}, this.emptyItem);
			this.zoneOptions.forEach(function(field){
				if(field.areacode == self.selectedUlb){
					self.selectedItem.state_id = field.state;
					if(field.parent > 0){
						self.selectedItem.zone_id = field.parent;
					}
					if(field.parent > 0){
						self.selectedItem.ulb_id = field.id;
					}
				}
			});
			this.$root.$emit('bv::show::modal', 'edit-model');
		},
		showUpdateModal(item, index, button) {
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'edit-model', button)
		},
		showViewModal(item, button){
			this.selectedItem = Object.assign({}, item);
			this.$root.$emit('bv::show::modal', 'view-model', button);
		},
		showDeleteModal(item){
			var self = this;
			this.$bvModal.msgBoxConfirm('Please confirm that you want to delete device.', {
				title: 'Please Confirm',
				size: 'sm',
				buttonSize: 'sm',
				okVariant: 'danger',
				okTitle: 'YES',
				cancelTitle: 'NO',
				footerClass: 'p-2',
				hideHeaderClose: false,
				centered: true
			})
			.then(value => {
				if(value == true){
					self.axios.post(self.deleteUrl, {
						accesskey: self.$session.get('access_key'),
						deleteid: item.id
					})
					.then(function (response) {
						if(response.data.error == 0 || response.data.error == '0'){
							self.$bvToast.toast(response.data.message, {
								title: 'Delete',
								toaster: 'b-toaster-bottom-right',
								autoHideDelay: 5000,
								variant: 'warning',
								solid: true,
								appendToast: true
							});
							self.initload();
						}
						
					})
					.catch(function (error) {
						alert(error);
					});
				}else{
					//alert('no '+item.id);
				}
			})
			.catch(err => {
				// An error occurred
				console.log(err);
			})
		},
		modalSubmit(bvModalEvt){
			var self = this;
			self.loading = true;
			bvModalEvt.preventDefault();
			var submitUrl = "";
			if(self.selectedItem.id == 0){
				submitUrl = self.insertUrl;
			}else{
				submitUrl = self.updateUrl;
			}


			self.axios.post(submitUrl, {
				accesskey: self.$session.get('access_key'),
				data: self.selectedItem
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.$bvModal.hide('edit-model');
					self.$bvToast.toast(response.data.message, {
						title: 'Status',
						toaster: 'b-toaster-bottom-right',
						autoHideDelay: 5000,
						variant: 'warning',
						solid: true,
						appendToast: true
					});
					self.initload();
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
		},
		
		

		resetSelectedItem(){
			var self = this;
			self.selectedItem = Object.assign({}, self.emptyItem);
		},
		loadzones(){
			var self = this;
			
			self.axios.post(self.zonesUrl, {
				accesskey: self.$session.get('access_key')
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.zoneOptions = response.data.result;
					self.zoneOptions.forEach(function(field){
						if(field.state == 'in-mh'){
							if(field.areacode == self.selectedUlb){
								self.zoneOptions.forEach(function(field2){
									if(field2.id == field.parent){
										self.page_title = field.title;//+', '+field2.title+', Maharastra';
									}
								});
								//self.page_title = field.title+', Maharastra';
							}
						}
					});
				}
			})
			.catch(function (error) {
				alert(error);
			});
		},
		initload(){
			var self = this;
			
			self.axios.post(self.recordUrl, {
				accesskey: self.$session.get('access_key'),
				ulbcode: self.selectedUlb
			})
			.then(function (response) {
				if(response.data.error == 0 || response.data.error == '0'){
					self.records = response.data.result.ulb_devices;
					self.zoneinfo = response.data.result.zoneinfo;
					self.loading = false;
					self.totalRows = self.records.length;

					self.last_sync_time = self.$moment().format('DD-MM-YYYY HH:mm:ss');

					self.total_lights = 0;
					self.total_light_on = 0;
					self.total_light_off = 0;
					self.total_signal_loss = 0;

					self.current_load = 0;
					self.total_load = 0;

					self.total_kwh = 0;

					self.device_on = 0;
					self.device_connected = 0;
					var sno = 1;
					self.records.forEach(function(field){
						field.sno = sno++;

						self.total_lights += field.no_of_fittings;
						
						self.total_load += parseInt(field.total_load);

						if(field.kwh && field.kwh != 'NaN'){
							self.total_kwh += parseInt(field.kwh);
						}

						//console.log(field.output_status+" "+(field.amp_r/1000)+" "+(field.amp_y/1000)+" "+(field.amp_b/1000));
						if(field.output_status == 0 && (parseInt(field.amp_r/1000) < self.$root.correction_amp || parseInt(field.amp_y/1000) < self.$root.correction_amp || parseInt(field.amp_b/1000) < self.$root.correction_amp)){
							// do nothing
						}else{
							if(field.total_kw && field.total_kw != 'NaN') self.current_load += parseInt(field.total_kw);
						}

						var curdatetime = self.$moment(); // i will replace this with server time by passing time in api
						var conn_status = 1;
						var dbdatetime = '';
						var duration = '';
						var minutes = '';
						if(field.data_fault == 1){
							dbdatetime = self.$moment(field.fault_time);
							
							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
							}
							minutes = duration.asMinutes();
							
							if(minutes < self.$root.disconnection_time){
								conn_status = 1;
							}else{
								conn_status = 0;
							}
						}
						else if(field.update_time != ""){
							dbdatetime = self.$moment(field.update_time);
							
							if(curdatetime > dbdatetime){
								duration = self.$moment.duration(curdatetime.diff(dbdatetime));
							}else{
								duration = self.$moment.duration(dbdatetime.diff(curdatetime));
							}
							minutes = duration.asMinutes();
							
							if(minutes < self.$root.disconnection_time){
								conn_status = 1;
							}else{
								conn_status = 0;
							}
						}else{
							conn_status = 0;
						}
						field.connection_status = conn_status;
						if(conn_status == 1){
							self.device_connected += 1;
						}
						if(field.output_status == 1 && conn_status == 1){
							self.device_on += 1;
							self.total_light_on += field.no_of_fittings;
						}
						if(field.output_status == 0 && conn_status == 1){
							self.total_light_off += field.no_of_fittings;
						}
						if(conn_status == 0){
							self.total_signal_loss += field.no_of_fittings;
						}
					});

					

					var min_lat = 100;
					var min_lng = 100;
					var max_lat = 0;
					var max_lng = 0;

					self.markers = [];

					//if(self.markers.length == 0 || self.records.length != self.markers.length){
						for (var i = 0; i < self.records.length; i++) {
							var d = self.records[i];

							var actual_load = 0;
							if(parseInt(d.total_kw/100000) > 0.5){
								actual_load = (d.total_kw/100000).toFixed(3);
							}

							var msg = '<b>CCMS ID: '+d.feeder_pillar_no+'</b><br><b>Location</b> : '+d.location+'<br><b>Latitude :</b> '+d.location_lat+'<br><b>Longitude :</b> '+d.location_lng+'<br><b>Total Lamps Connected :</b> '+d.no_of_fittings+'<br><b>Actual Load KW :</b> '+actual_load+'<br><b>Last Updated Time :</b> '+self.$moment(d.update_time).format('DD-MM-YYYY HH:mm:ss');

							min_lat = Math.min(d.location_lat, min_lat);
							min_lng = Math.min(d.location_lng, min_lng);

							max_lat = Math.max(d.location_lat, max_lat);
							max_lng = Math.max(d.location_lng, max_lng);

						//	console.log(min_lat+" "+min_lng+" "+max_lat+" "+max_lng);

						//	var color = 'blue';
							var blueurl = "https://www.fablurs.com/flag-blue.svg";//http://maps.gstatic.com/mapfiles/markers2/boost-marker-mapview.png";
							var redurl = "https://www.fablurs.com/flag-red.svg";
							var greenurl = "https://www.fablurs.com/flag-green.svg";
							var iconurl = blueurl;
							if(d.connection_status == 1){
								if(d.output_status == 1){
									iconurl = greenurl;
								}else{
									iconurl = redurl;
								}
							}
							
							//alert(iconurl);
							self.addMarker(self.records[i].location_lat, self.records[i].location_lng, msg, iconurl);

							/*blueurl = "http://maps.gstatic.com/mapfiles/markers2/boost-marker-mapview.png";
							redurl = "http://maps.gstatic.com/mapfiles/markers2/marker.png";
							greenurl = "http://maps.gstatic.com/mapfiles/markers2/icon_green.png";
							iconurl = blueurl;
							if(d.connection_status == 1){
								if(d.output_status == 1){
									iconurl = greenurl;
								}else{
									iconurl = redurl;
								}
							}
							
							//alert(iconurl);
							self.addMarker2(self.records[i].location_lat, self.records[i].location_lng, msg, iconurl);*/
						}
						self.center = { lat: min_lat + (max_lat - min_lat)/2, lng: min_lng + (max_lng - min_lng)/2 };
					//}
					setTimeout(self.initload, self.$root.reload_duration);
				}else{
					self.$root.forceLogout(response.data.message);
				}
				
			})
			.catch(function (error) {
				alert(error);
			});
			//alert('login '+self.email+" "+self.password);
		},
		onFiltered(filteredItems) {
			this.totalRows = filteredItems.length
			this.currentPage = 1
		},
		downloadcsv(){
			var self = this;
			var header = new Array()
			self.fields.forEach(function(item){
				if(!item.extra){
					header.push(item.label);
				}
			});
			
			//var d = table.rows().data();
			var finalarr = new Array();
			finalarr.push(header);
			self.records.forEach(function(row){
				var dataarr = new Array();
				self.fields.forEach(function(field){
					if(field.key != 'extra'){
						dataarr.push(row[field.key]);
					}
				});
				finalarr.push(dataarr);
			});
			
			let csvContent = "data:text/csv;charset=utf-8," 
			+ finalarr.map(e => e.join(",")).join("\n");

			var encodedUri = encodeURI(csvContent);
			var link = document.createElement("a");
			link.setAttribute("href", encodedUri);
			link.setAttribute("download", "device_report.csv");
			document.body.appendChild(link); // Required for FF

			link.click();
		}
	}
}
</script>
<style>
html{
	min-height: 100%;
}
body{
	background-color: '#FFF' !important;
	background-image: none !important;
}
.table{
	font-size: small;
}
.table .btn{
	font-size: 12px;
	font-weight: 600;
}
.table td, .table th{
	vertical-align: middle;
}


.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to{
  opacity: 0;
}
.header-title{
	padding: 0.3rem 1.25rem;
}

.badge{
	font-size: 85%;
}

.text-sm{
	font-size: 13px;
}
.text-md{
	font-size: 16px;
}
.text-lg{
	font-size: 18px;
}
</style>